module.exports = __webpack_public_path__ + "img/notified-01.12f01f95.svg";